<script setup lang="ts">
import { modalTransition } from '@/plugins/transitions';
import { ref, watch } from 'vue'
import { useGroupStore } from '@/store/group';
import { useI18n } from '@/composable/useI18n';

const { t } = useI18n()

const props = defineProps<{
  isOpen: boolean
  groupId: number
}>()

const emit = defineEmits(['close', 'saved'])
 
const formData = ref({
  is_line_setup: false,
  active_power_outage_alarm: false,
})

const storeGroup = useGroupStore()

watch(
  () => props.isOpen,
  (newValue) => {
    if (newValue && props.groupId) {
        const group = storeGroup.groups.find(g => g.id === props.groupId)
        if (group) {
            formData.value.is_line_setup = group.is_line_setup ?? false
            formData.value.active_power_outage_alarm = group.active_power_outage_alarm ?? false
        }
    }
  },
  { immediate: true },
)

function cancel() {
  emit('close')
}

const handleSave = () => {
    emit('saved', {...formData.value})
    emit('close')
}

</script>

<template>
  <transition v-bind="modalTransition">
    <div v-if="isOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div class="mx-auto w-full max-w-md bg-white p-6 shadow-4">
        <div class="mb-4 flex items-start justify-between">
          <div>
            <h2 class="text-xl font-semibold">{{ t('groups.alarms_title') }}</h2>
            <p class="text-sm text-gray-600">{{ t('groups.alarms_subtitle') }}</p>
          </div>
          <button @click="cancel" class="hover:text-slate-400">
          </button>
        </div>

        <form @submit.prevent="handleSave">
          <div class="space-y-4">
            <div class="flex items-center">
              <input
                id="line-setup"
                v-model="formData.is_line_setup"
                type="checkbox"
                class="h-4 w-4 border-gray-300 text-blue focus:ring-0 hover:bg-gray-100" />
              <label for="line-setup" class="ml-3 block text-sm font-medium text-gray-700">
                {{ t('groups.line_setup') }}
              </label>
            </div>
            <div class="flex items-center">
              <input
                id="power-outage"
                v-model="formData.active_power_outage_alarm"
                type="checkbox"
                class="h-4 w-4 border-gray-300 text-blue focus:ring-0 hover:bg-gray-100" />
              <label for="power-outage" class="ml-3 block text-sm font-medium text-gray-700">
                {{ t('groups.power_outage_alarm') }}
              </label>
            </div>
          </div>

          <div class="mt-6 flex justify-end space-x-4">
            <button
              type="submit"
              class="bg-blue px-4 py-2 text-white shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
              {{ t('globals.buttons.save') }}
            </button>
            <button @click="cancel" type="button" class="text-slate-500 hover:text-slate-400">
              {{ t('globals.buttons.cancel') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </transition>
</template>